class SectionPromoBar extends HTMLElement {
  constructor() {
    super();
    this.initFunction();
  }

  initFunction() {
    window.loadSwiper.then(({ Swiper, Autoplay, EffectFade }) => {
      const swiperParams = {
        modules: [Autoplay, EffectFade],
        slidesPerView: 1,
        speed: 100,
        loop: true,
        autoplay: { delay: 2000, disableOnInteraction: true },
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
      };

      this.swiper = new Swiper(this.querySelector(".swiper"), swiperParams);

      // Navigation doesn't work properly with loop and effectfade so we have to do it manually
      this.querySelector("[data-swiper-next]")?.addEventListener(
        "click",
        () => {
          const nextIndex =
            this.swiper.activeIndex + 1 < this.swiper.slides.length
              ? this.swiper.activeIndex + 1
              : 0;
          this.swiper.slideTo(nextIndex);
        },
      );

      this.querySelector("[data-swiper-prev]")?.addEventListener(
        "click",
        () => {
          const nextIndex =
            this.swiper.activeIndex === 0
              ? this.swiper.slides.length - 1
              : this.swiper.activeIndex - 1;
          this.swiper.slideTo(nextIndex);
        },
      );

      this.swiper.on("slideChange", () => {
        this.dataset.activeIndex = this.swiper.realIndex;
      });
    });
  }
}

if (!customElements.get("section-promo-bar")) {
  customElements.define("section-promo-bar", SectionPromoBar);
}
